import { navigateToResolved } from '@Actions/navigate.action';
import { getValue } from '@Selectors';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

export default function useNavigateTo() {
	const history = useHistory();
	const dispatch = useDispatch();
	const { navigateTo } = useSelector(getValue).navigate;

	React.useEffect(() => {
		if (navigateTo) {
			history.push(navigateTo);
			dispatch(navigateToResolved());
		}
	}, [navigateTo]);
}
